<div (click)="showSelectorDialog()">
  <span class="selected" *ngFor="let s of selected">{{ s ? s.name : '' }}</span>
</div>
<div *ngIf="selected.length === 0">
  <button mat-raised-button (click)="showSelectorDialog()" size="small">{{ placeholder }}</button>
</div>